import {useContext, useState} from 'react'
import * as _ from 'lodash-es'
import {RoundedButton} from '../GameCompsF.jsx'
import { GameContext } from '../GameContextF.jsx'
import { useAction } from '../useAction.js'
import { Heading, Checkbox, Box, VStack } from '@chakra-ui/react'

const KickPlayerRow = ({playerAlias, blockIp, onKicked}) => {
  const {doAction, loading} = useAction({playerAction: 'kickPlayer', playerAlias, blockIp})
  const onClick = () => {
    doAction?.()
    onKicked()
  }
  return <RoundedButton {...{isLoading: loading, my: 2, onClick, size: 'sm'}}>
    {playerAlias}
  </RoundedButton>
}

export const ChooseKickPlayer = () => {
  const {publicStates, setIsKickingPlayer, playerAlias: myPlayerAlias} = useContext(GameContext)
  const [blockIp, setBlockIp] = useState(false)

  const otherPlayers = _.filter(_.keys(publicStates), alias => alias !== myPlayerAlias)

  return <Box>
    <Heading {...{mb: 6, size: 'md'}}>Kick Player</Heading>
    <VStack {...{spacing: 2, mb: 4}}>
      {otherPlayers.map(playerAlias => 
        <KickPlayerRow key={playerAlias} {...{playerAlias, blockIp, onKicked: () => setIsKickingPlayer(false)}} />
      )}
    </VStack>
    <Box {...{my: 4, py: 2, borderTop: '1px solid', borderColor: 'gray.600'}}>
      <Checkbox {...{isChecked: blockIp, onChange: (e) => setBlockIp(e.target.checked), colorScheme: 'red'}}>
        Block this player's IP?
      </Checkbox>
    </Box>
    <RoundedButton {...{onClick: () => setIsKickingPlayer(false), size: 'sm'}}>Cancel</RoundedButton>
  </Box>
}